import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _types$SET_WISHLIST_I;

import * as types from './types';
export default (_types$SET_WISHLIST_I = {}, _defineProperty(_types$SET_WISHLIST_I, types.SET_WISHLIST_ITEMS, function (state, payload) {
  var currentState = state;
  currentState.items = payload.products;
}), _defineProperty(_types$SET_WISHLIST_I, types.ADD_WISHLIST_ITEM, function (state, payload) {
  var currentState = state;
  currentState.items.push(payload);
}), _defineProperty(_types$SET_WISHLIST_I, types.DELETE_WISHLIST_ITEM, function (state, payload) {
  var currentState = state;
  var index = currentState.items.findIndex(function (_ref) {
    var reference = _ref.reference;
    return reference === payload;
  });
  currentState.items.splice(index, 1);
}), _defineProperty(_types$SET_WISHLIST_I, types.SET_WISHLIST_PRODUCTS, function (state, payload) {
  var currentState = state;
  currentState.products = payload.products;
}), _types$SET_WISHLIST_I);